import { useEffect, useState } from "react";
import logo from "../../assets/logo-main.svg";
import "./preLoader.css";

const PreLoader = () => {
  const [progress, setProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(progressInterval);
          setIsVisible(false); // Hide preloader
          return 100;
        }
        return prev + 1; // Increment progress by 1%
      });
    }, 50); // Update every 50ms

    return () => clearInterval(progressInterval); // Cleanup interval
  }, []);

  if (!isVisible) return null; // Hide preloader when not visible

  return (
    <div id="preloader" className="preloader">
      <div>
        <img id="logo" className="logo" src={logo} alt="Logo" />
        <div id="progress-bar" className="progress-bar">
          <div
            id="progress-bar-fill"
            className="progress-bar-fill"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default PreLoader;